
import {focus} from 'vue-focus'
import dropdown from 'vue-dropdowns'
import {mapGetters, mapMutations} from 'vuex'
import {fetchCart} from '@/api/cart'
import {fetchUser} from '@/api/user'
import {fetchResource, addToCart, deleteFromCart, addToCollection} from '@/api/resource'
import {formatNumInTenThousand} from '@/utils/index'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'


export default {
computed: {
...mapGetters([
'profile',
'taxonomyList'
])
},
components: {
dropdown,
Actionsheet,
Search,
Tab,
TabItem,
XSwitch,
Group,
Scroller
},
data () {
return {
show1: false,
menus1: {
menu1: '综合排序',
menu2: '粉丝量'
},
show2: false,
menus2: {
menu1: '从高到低',
menu2: '从低到高'
},
menu1Current: '综合排序',
menu2Current: '从高到低',
inputShowed: false,
activeIndex: 0,
searchStatus: false,
searchFilter: {
q: '',
_mode: 'es',
'sort_field': '',
'sort_direct': 'descend',
page: 1
},
sortDescName: ['从高到低', '从低到高'],
sortDescNameWeb: [{name: '从高到低'}, {name: '从低到高'}],
sortDescValue: ['descend', 'ascend'],
currentSortField: {
name: '综合排序'
},
currentSortDirect: {name: '从高到低'},
resourceData: [],
show4: false,
show5: false,
actionMenu: {
0: '加入到收藏夹',
1: '加入到购物车'
},
priceMenu: {
0: '',
1: ''
},
currentResource: {},
currentResourceIndex: {},

cartGoodsNumber: 0,
iconLink: '',
pullupDefaultConfig: {
content: '上拉加载更多',
pullUpHeight: 60,
height: 40,
autoRefresh: false,
downContent: '释放后加载',
upContent: '上拉加载更多',
loadingContent: '加载中...',
clsPrefix: 'xs-plugin-pullup-'
}
}
},
directives: {
focus: focus
},

methods: {
...mapMutations({
setTitleVuex: 'SET_TITLE',
setProfile: 'SET_PROFILE'
}),
log (str) {
console.log(str)
},
click (key) {
console.log(key)
},

showInput () {
this.inputShowed = true
},
hideInput () {
this.searchFilter.q = ''
this.inputShowed = false
},
clearInput () {
this.searchFilter.q = ''
},
handlesearch () {
this.getDataByTab()
},

tabClick (idx) {
this.$router.push('/media?tab=' + this.taxonomyList[idx].tabType)
this.activeIndex = idx
this.changeNavTitle()
this.getDataByTab()
this.getCartNumber()
},

getTabStatus () {

if (!this.$route.query.search) {
this.activeIndex = this.$route.query.tab ? this.taxonomyList.map(item => item.tabType).indexOf(this.$route.query.tab) : 0
this.getDataByTab()
} else {
this.resourceData = []
}
this.changeNavTitle()
},

changeNavTitle () {
const title = this.taxonomyList[this.activeIndex].name
this.setTitleVuex(title)
document.title = title
this.menu1Current = '综合排序'
this.menu2Current = '从高到低'
},

changeSortField (e) {
this.menu1Current = this.taxonomyList[this.activeIndex].sortName[e]
let idx
this.taxonomyList[this.activeIndex].sortName.map((item, index) => {
if (item === this.menu1Current) {
idx = index
}
})
this.searchFilter.sort_field = this.taxonomyList[this.activeIndex].sortField[idx]
this.getDataByTab()
},

changeSortDirect (e) {
this.menu2Current = this.menus2[e]
let idx
this.sortDescName.map((item, index) => {
if (item === this.menu2Current) {
idx = index
}
})
this.searchFilter.sort_direct = this.sortDescValue[idx]
this.getDataByTab()
},

getCartNumber () {
if (!this.profile.id) {
this.cartGoodsNumber = 0
} else {
fetchCart(this.taxonomyList[this.activeIndex].tabType).then(resp => {
this.cartGoodsNumber = resp.data.length
}).catch((e) => console.log('error', e))
}
},

loadmore (loaded) {
this.getDataByTab('loadmore')
setTimeout(() => {
loaded('done')
}, 1000)
},

stateChange (state) {
if (state === 'pull' || state === 'trigger') {
this.iconLink = '#icon-arrow-bottom'
} else if (state === 'loading') {
this.iconLink = '#icon-loading'
} else if (state === 'loaded-done') {
this.iconLink = '#icon-finish'
}
},

getDataByTab (loadmore) {
if (loadmore === 'loadmore') {
++this.searchFilter.page
} else {
this.searchFilter.page = 1
this.resourceData = []
}
const tabType = this.taxonomyList[this.activeIndex].tabType
fetchResource(tabType, this.searchFilter).then(resp => {
const resourceDataNew = resp.data.map(data => {
const avgReadNum = formatNumInTenThousand(data.analysis.avg_read_num)
const fansNum = formatNumInTenThousand(data.analysis.fans_num)
const avgPlayNum = formatNumInTenThousand(data.analysis.avg_play_num)
const avgAudienceNum = formatNumInTenThousand(data.analysis.avg_audience_num)
const price = formatNumInTenThousand(data.quote.price)
const priceSecond = formatNumInTenThousand(data.quote.price_second)
const cartStatus = data.cart && data.cart.created_at
const likeNum = formatNumInTenThousand(data.analysis.avg_like_num)
const priceBoxIsShow = false
return {
...data,
avgReadNum,
fansNum,
avgPlayNum,
price,
priceSecond,
cartStatus,
priceBoxIsShow,
likeNum,
avgAudienceNum
}
})
if (loadmore === 'loadmore') {
this.resourceData = this.resourceData.concat(resourceDataNew)
} else {
this.resourceData = resourceDataNew
}
this.$nextTick(() => {
this.$refs.scrollerBottom.donePullup()
})
}).catch((e) => console.log('error', e))
},
handleAddToCart (data, index, priceType) {
if (!priceType) {
priceType = this.taxonomyList[this.activeIndex].priceType[0] || ''
}
addToCart(data.id, this.taxonomyList[this.activeIndex].tabType, priceType).then(resp => {

this.resourceData[index].cart = {item_id: resp.data.item_id}
this.resourceData[index].cartStatus = true
this.$vux.toast.show({
text: '成功加入购物车'
})
++this.cartGoodsNumber
}).catch((e) => {
this.$vux.toast.show({
text: e.message
})
})
},
handleDeleteFromCart (cartId, index) {
deleteFromCart(cartId).then(resp => {

this.resourceData[index].cart = null
this.resourceData[index].cartStatus = false
--this.cartGoodsNumber
}).catch((e) => {
})
},
console (msg) {
console.log(msg)
},

actionShow (item, index) {
this.show4 = true
this.currentResource = item
this.currentResourceIndex = index
},
handleChoose (key) {
if (key === '1') {
this.show5 = true
this.priceMenu[0] = this.taxonomyList[this.activeIndex].priceTypeName[0] + this.currentResource.price
this.priceMenu[1] = this.taxonomyList[this.activeIndex].priceTypeName[1] + this.currentResource.priceSecond
} else {
addToCollection(this.currentResource.id, this.taxonomyList[this.activeIndex].tabType).then(resp => {
this.$vux.toast.show({
text: resp.message
})
})
}
},
selectPrice (key) {
this.handleAddToCart(this.currentResource, this.currentResourceIndex,
this.taxonomyList[this.activeIndex].priceType[key])
}
},
beforeMount () {
this.getTabStatus()
fetchUser().then(resp => {
this.setProfile(resp.data)
this.getCartNumber()
})
},
mounted () {
this.$nextTick(() => {
this.$refs.scrollerBottom.reset({top: 0})
})
}



}



// WEBPACK FOOTER //
// ./src/pages/media/index.vue